import { useRequest } from "../../../shared/hooks/useRequest";
import { getMyCourses } from "../api/accountApi";

// getMyCourses lives at module level, so its identity is stable and the request runs once
export const useMyCourses = () => useRequest(getMyCourses);